export default "__VITE_ASSET__Ctg6oWda__"